/**
 * Region entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Region extends BaseModel {
    defaults() {
        return {
            id: null,
            region: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'Region';
    }
}

export class RegionCollection extends BaseCollection {
    options() {
        return {
            model: Region,
        };
    }

    entityName() {
        return 'Region';
    }
}
